const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.ogg'];

// Detects a video advertisement by its URL extension (T008A image-vs-video).
export const isVideoUrl = (url: string) => {
  const path = url.toLowerCase().split('?')[0] ?? '';
  return VIDEO_EXTENSIONS.some(extension => path.endsWith(extension));
};
